import { MachineEventType } from "@enums/machineEventType.enum";
import { Model } from "@interfaces/model.interface";

export interface ProductionToolEvent extends Model {
	completed: boolean;
	description: string;
	downTimeCost: number;
	downTimeHours: number;
	eventClosed: Date;
	eventImageURL: string;
	eventOpened: Date;
	eventType: MachineEventType;
	productionToolId: number;
	reporterId: number;
}

export class ProductionToolEvent implements ProductionToolEvent {
	constructor(data?: Partial<ProductionToolEvent>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}